import Vue from "vue";
import VueRouter from "vue-router";
// Guard
import { defaultGuard } from "@/middlewares/guards";
// Layouts
import LoginLayout from "../layouts/LoginLayout.vue";
// Views
import Login from "../views/Login.vue";

// Module routes
import stationRoutes from "@/router/station.routes";
import logisticRoutes from "@/router/logistic.routes";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    component: LoginLayout,
    beforeEnter: defaultGuard,
    children: [
      {
        path: "",
        name: "Login",
        component: Login,
        meta: {
          title: "Inicio de sesión",
        },
      },
    ],
  },
  {
    path: "/",
    redirect: "/reception/1/process/",
  },
  {
    path: "/reception",
    redirect: "/reception/1/process/",
  },
  ...stationRoutes,
  ...logisticRoutes,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const DEFAULT_TITLE = "Solena Admin";
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
